const Options = {
	HOTEL_RESERVATION: { id: 1, name: 'hotel-reservation', component: 'hotel-prices', passEvent: true },
	TRANSFER_RESERVATION: { id: 2, name: 'transfer', component: 'transfer-price', passEvent: true },
	DESTINATION_INFORMATION: { id: 3, name: 'destination-info', component: 'destination-info', passEvent: true },
	ABOUT_BRAZIL: { id: 4, name: 'about-brazil', component: 'about-brazil', passEvent: false },
	VISA_AND_VACCINE: { id: 5, name: 'visa-and-vaccine', component: 'visa-and-vaccine', passEvent: true },
	EVENT_PROMOTER_WEBSITE: { id: 6, name: 'web-site-event-promoter', component: null, passEvent: false },
	LOCAL_TOURS: { id: 7, name: 'local-tour', component: 'local-tour-price', passEvent: true },
	FLIGHT_REQUEST: { id: 8, name: 'flight-request', component: 'flight-reservation', passEvent: true },
	PRE_POST_TOUR: { id: 9, name: 'pre-post-tour', component: 'pre-post-tours', passEvent: true },
};

export default Options;
export const options = Object.keys(Options).map(key => Options[key]);



// WEBPACK FOOTER //
// ./src/enums/Options.js